export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_ERROR = 'FETCH_PROFILE_ERROR';

export const EDIT_PROFILE = 'EDIT_PROFILE';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_ERROR = 'EDIT_PROFILE_ERROR';

export const SWITCH_PROFILE = 'SWITCH_PROFILE';
export const SWITCH_PROFILE_SUCCESS = 'SWITCH_PROFILE_SUCCESS';
export const SWITCH_PROFILE_ERROR = 'SWITCH_PROFILE_ERROR';

export const FETCH_LOOKUP_PROFILE_SUCCESS = 'FETCH_LOOKUP_PROFILE_SUCCESS';
export const CLEAR_USER_PROFILE_ERROR = 'CLEAR_USER_PROFILE_ERROR';
export const DOWNLOAD_DOCUMENT_LOADING = 'DOWNLOAD_DOCUMENT_LOADING';
export const DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS';
export const DOWNLOAD_DOCUMENT_ERROR = 'DOWNLOAD_DOCUMENT_ERROR';

export const PERMISSION_LOADING = 'PERMISSION_LOADING';
export const PERMISSION_SUCCESS = 'PERMISSION_SUCCESS';
export const PERMISSION_ERROR = 'PERMISSION_ERROR';
